import { useEffect, useState } from "react";
import { axiosBaseURL, getChapterParam } from "../../../http";
import { toast } from "react-toastify";
import { Row, Spinner } from "react-bootstrap";
import { NoneFound } from "../../../core/none_found";

export const ContactData = ({ type_value }) => {
    const [data, setData] = useState(null)
    useEffect(() => {
        const chapter_param = getChapterParam()
        axiosBaseURL.get(`contact_api/contacts/?type__type_value=${type_value}&${chapter_param}`).then(function (response) {
            setData(response.data)
        }).catch(function (error) {
            toast.error('Failed to fetch types')
        });
    }, [type_value]);
    return (
        <>
            {data === null ? (
                <Row className="justify-content-center">
                    <Spinner animation="border" role="status" variant="primary">
                        <span className="visually-hidden">Loading…</span>
                    </Spinner>
                </Row>
            ) : Array.isArray(data) && data.length > 0 ? (

                <>
                    {
                        data.map((item, index) => (
                            <div key={index} className="border-bottom mb-2">
                                <h5>{item.contact_name}</h5>
                                <a class="text-decoration-none" href={`tel:${item.phone_num}`}>{item.phone_num}</a>
                            </div>
                        ))
                    }
                </>
            ) : (
                <Row className="justify-content-center">
                    <NoneFound />
                </Row>
            )}
        </>
    )
}